import {
  IDeductionRepository,
  ISendRemittanceForApprovalRepositoryParams,
  ISendRemittanceForApprovalRepositoryResponse,
} from "@/core/repositories/deduction";

export class SendRemittanceForApprovalUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(
    params: ISendRemittanceForApprovalRepositoryParams,
    currentPage: number
  ): Promise<ISendRemittanceForApprovalRepositoryResponse> {
    return this.deductionRepository.sendRemittanceForApproval(params, currentPage);
  }
}
